module.exports = __webpack_public_path__ + "img/featuredartist (4).442a062e.jpg";